import 'fomantic-ui/dist/semantic.css';
import 'fomantic-ui';
import React from 'react'
import { createRoot } from 'react-dom/client'
import 'nodep-date-input-polyfill';
// import 'lazysizes';
import '../css/tailwind.scss'
import LoginModal from '../components/login_modal';
import '../category_filter/style.scss'
import '../common/global.scss';
import '../../assets/stylesheets/application.less';
import Turbolinks from "turbolinks"
import Rails from '../common/safe_rails_ujs'
import '../../assets/javascripts/libs/multiple-emails.js'
import WelcomeTour from '../components/welcome_tour/WelcomeTour'
import { registerTurbolinksTeardown } from '../lib/tour/tourManager'
import { initShopperTour } from '../lib/tour/tours/shopperTour'

if (!window._rails_loaded) {
  Rails.start()
}
Turbolinks.start()
registerTurbolinksTeardown()

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

let linksListenersInitialized = false;

function safeListenToLinks() {
  if (!linksListenersInitialized) {
    listenToLinks();
    linksListenersInitialized = true;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initSemanticUIComponents();
  safeListenToLinks();
});

document.addEventListener("turbolinks:load", () => {
  initSemanticUIComponents();
  safeListenToLinks();
  initShopperTour();
});

function initSemanticUIComponents() {
  // Re-run on every turbolinks:load — Turbolinks replaces <body>, so Fomantic UI
  // bindings on the previous DOM are gone and the new dropdowns/modals/etc. need to be re-bound.
  $('.ui.accordion').accordion();
  $('.ui.dropdown').dropdown();
  $('.user-menu').dropdown('setting', 'onShow', () => {
    document.dispatchEvent(new Event('topbar-notifications:close'));
  });
  $('.ui.modal').modal();
  $('.ui.popup').popup();

  document.querySelectorAll(".mobile-hover-dropdown").forEach(menu => {
    menu.addEventListener("click", (e) => {
      const submenu = e.target.querySelector(".menu")
      submenu && submenu.classList.toggle("hidden")
    })
  })
}

function listenToLinks() {

  const LoginModalContainer = document.getElementById('LoginModal')
  if (LoginModalContainer) {
    const LoginModalRoot = createRoot(LoginModalContainer)
    const LoginModalFilters = JSON.parse(LoginModalContainer.dataset.params)
    LoginModalRoot.render(<LoginModal {...LoginModalFilters} />)
  }

  const whitelist = window.privateUrls || [];

  const targetTypeByURL = {
    'buy_ticket': '/buy_ticket',
    'hire': '/purchases/new',
    'class': '/classes',
    'service': '/services',
    'product': '/products',
    'event': '/events',
    'project': '/projects',
    'nonprofit': '/nonprofits',
    'sign_up': '/sign_up',
    'offer': '/offer',
    'chat': '/chat'
  }

  if (whitelist.length > 0) {
    document.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (whitelist.find((url) => event.target.href && event.target.href.includes(url))) {
          const selectType = Object.keys(targetTypeByURL).find((type) => event.target.href.includes(targetTypeByURL[type]))
          let eventData = new CustomEvent("OpenLoginModal", {
            detail: {
              open: true,
              targetType: selectType || 'other',
              targetUrl: event.target.href,
              activeTab: event.target.href.includes('sign_in') ? 1 : 0
            }
          });
          window.dispatchEvent(eventData)
          event.preventDefault()
        }
      })
    })
  }

  // Mount Welcome Tour
  const welcomeTourContainer = document.getElementById('welcome-tour-root')
  if (welcomeTourContainer) {
    const welcomeTourRoot = createRoot(welcomeTourContainer)
    welcomeTourRoot.render(<WelcomeTour />)
  }

}
